module.exports = __webpack_public_path__ + "img/top-bg.2fe7acf3.jpg";